// extracted by mini-css-extract-plugin
export default {"lastUpdated":"TermsOfService_lastUpdated__Vdfsr marketplaceBodyFontStyles"};